import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CdkTextareaAutosize, TextFieldModule } from '@angular/cdk/text-field';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { DialogBase, MessagePriority, Receiver } from 't4core';
import * as moment from 'moment';
import { type } from 'os';


@Component({
    selector: 'msg-SendMessageDialog',
    templateUrl: 'SendMessageDialog.html',
})
export class SendMessageDialog extends DialogBase implements OnInit {

    public tmpReceiver: string = "Brenderup";
    public txtReceivers = new FormControl();
    public filteredReceivers: Observable<Receiver[]>;
    public selectedReceivers: Receiver[] = [];

  public validFrom: moment.Moment;
  public validThrough: moment.Moment;
  public language: string;
  public priority: MessagePriority = MessagePriority.Email;
  public requireReadConfirmation: boolean = false;

  public priorities: MessagePriority[] = [];
  public languages: string[] = [ 'en', 'sv', 'da', 'no' ];

    public subject: string = "";
    public content: string = "";

    @ViewChild('receiverInput', {static: false}) receiverInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto', {static: false}) matAutocomplete: MatAutocomplete;

    constructor(
        public dialogRef: MatDialogRef<SendMessageDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      super("SendMEssageDialog");

      this.language = this.Settings.clientSettings.Language;

        this.filteredReceivers = this.txtReceivers.valueChanges.pipe(
            debounceTime(300),
            switchMap(async value => (await this.Api.get<Receiver[]>("Messaging/GetReceivers", { search: value })).filter(x => !this.selectedReceivers.some(y => y.ReceiverId == x.ReceiverId))));

        if (this.Settings.getUser().Username == 'Björn') this.priorities.push(MessagePriority.Random);
        this.priorities.push(MessagePriority.Banner);
        this.priorities.push(MessagePriority.UrgentBanner);
        this.priorities.push(MessagePriority.Email);
        this.priorities.push(MessagePriority.Priority);
        this.priorities.push(MessagePriority.Urgent);

    //    if (this.Settings.isInAny(["Clerk", "LocationManager", "GroupManager"])) {
    //        this.selectedReceivers.push({ ReceiverId: "Feedback", FriendlyName: "Brenderup", Description: "", AddAsDefault: true, LocationId: null, GroupId: 0, Type: 3 });
    //    }
  }

  async ngOnInit() {

    if ((this.data?.type ?? "") === "Counting") {
      this.selectedReceivers.push({ ReceiverId: "OneWay Stations", FriendlyName: "OneWay Stations", Description: "All OneWay enabled locations", AddAsDefault: false, LocationId: null, GroupId: 0, Type: 3 })
      this.subject = "Inventering  - Oneway"
      this.content = this.data.content;
    }
  }



    addReceiver(event: MatChipInputEvent): void {
        if (!this.matAutocomplete.isOpen) {
            const input = event.input;
            const value = event.value;

            this.txtReceivers.setValue(null);
        }
    }

    removeReceiver(receiver: Receiver): void {
        const index = this.selectedReceivers.indexOf(receiver);

        if (index >= 0) {
            this.selectedReceivers.splice(index, 1);
        }
    }

    selectReceiver(event: MatAutocompleteSelectedEvent): void {
        this.selectedReceivers.push(event.option.value);
        this.receiverInput.nativeElement.value = '';
      this.txtReceivers.setValue(null);
      console.log(this.selectedReceivers);
    }

  public async send() {
    if (!this.Settings.isInAny(['OneWayAdmin', 'Admin'])) {
      if (this.tmpReceiver == "Brenderup")
        this.selectedReceivers.push({ ReceiverId: "Feedback", FriendlyName: "Brenderup", Description: "", AddAsDefault: true, LocationId: null, GroupId: 0, Type: 3 });
      else
        this.selectedReceivers.push({ ReceiverId: "OneWay", FriendlyName: "OneWay", Description: "", AddAsDefault: true, LocationId: null, GroupId: 0, Type: 3 });
    }

        try {
            var result = await this.Api.post<boolean>("Messaging/PlaceMessage", JSON.stringify(this.selectedReceivers), {
                subject: this.subject,
                content: this.content,
                language: this.language,
                validFrom: this.validFrom ? this.validFrom.toISOString() : null,
              validTo: this.validThrough ? this.validThrough.toISOString() : null,
                priority: this.priority,
                requireConfirmation: this.requireReadConfirmation
            });

            if (result) {
              this.UI.alert("Turbo.Messaging.SendMessageDialog.headMessageSent", "The message has been sent!", "Turbo.Messaging.SendMessageDialog.msgMessageSent", 'The message was sent successfully. Any response will be sent to your registered email address.');

              if ((this.data?.type ?? "") === "Counting") {
                this.dialogRef.close(this.data);
              }
              else {
                this.dialogRef.close();
              }
            }
        } catch (ex) {
            this.UI.alert("Turbo.Messaging.SendMessageDialog.headMessageError", "Delivery failed!", "Turbo.Messaging.SendMessageDialog.msgMessageError", 'The message could not be sent. Please review the settings and try again.');
        }
    }
}
